import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Progress } from './progress.model';
import { ProgressService } from './progress.service';


@Injectable()
export class ProgressGuard implements Resolve<Progress> {

  constructor(public router: Router, private progressService: ProgressService) { }

  private progressId: string;

  resolve(route: ActivatedRouteSnapshot) {
    this.progressId = route.params['progressId'];
    return this.progressService.getProgressById(this.progressId);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/progress/progress.guard.ts